import { html, type Html, Page, rune, View } from 'rune-ts';
import klass from './CurationDetail.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { Header } from '../../components/cells/Header/Global/Header.ts';
import { $delegate, $qs } from 'fxdom/es';
import { listenDocumentEvent } from '../../../shared/util/event';
import { go } from 'fxjs/es';
import { MShopUtilF } from '../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { map, noop, pipe, reject, take, toArray } from '@fxts/core';
import { main_detail } from '../../../../../modules/MShop/App/Today/S/Tmpl/main_detail';
import UAParser from 'ua-parser-js';
import { CurationDetail, CurationListItem, NearCurationItem } from '../../../features/Curation/type';
import header_klass from '../../components/cells/Header/Global/Header.module.scss';
import { hydrateFeed } from './util';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { Confirm } from '@services/MarppleShop/renderApp/components/cells/Confirm/Confirm.ts';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';
import { pushLoginStack } from '@modules/Creator/Login/F/fs';
import { CurationThumbnailView } from '@services/MarppleShop/renderApp/pages/Curation/components/CurationThumbnailView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { CardProductView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';
import { classes } from '@services/MarppleShop/shared/util';
import { updateLikeMarppleShop } from '@modules/MShop/App/Product/Item/F/Function/updateLikeMarppleShop';
import { CardCurationView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardCurationView.ts';
import { ButtonView } from '@services/MarppleShop/shared/components/atoms/Buttons/ButtonView.ts';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { IconsBasicEnquadArrowChevronRightIcon } from '@services/MarppleShop/shared/components/atoms/Icon';
import { mpsPostMessage } from '@services/MarppleShop/shared/app/util.ts';

const LATEST_CURATION_LIMIT = 4;

export type CurationDetailPageData = {
  layout_options: BaseLayoutOptions;
  curations: CurationListItem[];
  curation_detail: CurationDetail;
  next_curation: NearCurationItem | undefined;
  prev_curation: NearCurationItem | undefined;
  is_app: boolean;
  from_page: string | undefined;
};

class BodyView extends View<CurationDetailPageData> {
  /**
   * @see https://github.com/marpple/marpple-web/blob/c69213b737c26d28b5417bc5767aaf4a2b953760/services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardView.ts#L301-L329
   */
  private async handleCardProductLikeClick(product_id: number) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const target_curation_product = this.data.curation_detail.products.find(
      (product) => product.id === product_id,
    )!;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!target_curation_product.user_id || window.box.sel('is_user->type') == 'TEMP') {
      const confirmed = (await Confirm.open({
        title: ET('mps2::login::need_login::title'),
        message: preventEscape(ET('mps2::login::need_login::message')),
        confirmText: ET('mps2::login::login'),
        cancelText: ET('mps2::signup::close'),
      })) as boolean;

      if (confirmed) {
        if (MShopUtilF.isApp()) {
          pushLoginStack();
        } else {
          location.href = `/${T.lang}/@/login?url=${location.pathname + location.search}`;
        }
      }
    } else {
      try {
        const next_is_liked = !target_curation_product.is_liked;
        updateLikeMarppleShop(!next_is_liked, target_curation_product.stores_product_id);

        this.data.curation_detail.products = this.data.curation_detail.products.map((product) =>
          product.id === product_id ? { ...product, is_liked: next_is_liked } : product,
        );
        this.subViews(CardProductView)
          .filter((card_product_view) => card_product_view.data.product_image.id === product_id)
          .forEach((card_product_view) => card_product_view.setProductImageIsLiked(next_is_liked));
      } catch {
        noop();
      }
    }
  }

  protected override template({
    curation_detail,
    curations,
    layout_options: { is_mobile },
    next_curation,
    prev_curation,
    is_app,
    from_page,
  }: CurationDetailPageData) {
    return html`<div class="${klass.body}">
      ${is_mobile
        ? new CurationThumbnailView({
            ...curation_detail,
            device: 'Mobile',
            theme: curation_detail.theme === 'Light' ? 'Dark' : 'Light',
          })
        : null}
      ${html.preventEscape(
        main_detail({
          is_mobile,
          today: curation_detail,
          next_today: next_curation,
          prev_today: prev_curation,
          is_sharable: !is_mobile,

          steps: null,
          feed_category_id: null,
          products_html: null,
          related_section_title: null,
          related_todays_html: null,
          show_related_see_more: null,
        }),
      )}

      <div class="${klass.curation_products}">
        <span class="${font('24_bold', '18_semibold')}">
          ${ET('curation::curation_detail_page::related_products')}</span
        >

        <div class="${klass.product_list}">
          ${curation_detail.products.map(
            (product) =>
              new CardProductView({
                type: 'G',
                size: is_mobile ? 'Xsmall' : 'Large',
                layout: 'Vertical',
                theme: 'Light',
                state: CardProductView.getState(product),
                product_image: {
                  domain_name: product.domain_name,
                  thumbnail_info: product.thumbnail_info,
                  resize_width: 126 * 2,
                  is_lazy: true,
                  is_liked: product.is_liked,
                  name: product.name,
                  id: product.id,
                  store_name: product.store_name,
                },
                product_title: {
                  id: product.id,
                  domain_name: product.domain_name,
                  name: product.name,
                },
                price: {
                  price: product.price,
                  price_en: product.price_en,
                  price_jp: product.price_jp,
                },
                review: {
                  review_count: product.review_count,
                  review_score: product.review_score,
                },
                count_view: {
                  watcher_count: product.watcher_count ?? 0,
                },
                onProductImageLikeClick: () => this.handleCardProductLikeClick(product.id),
              }),
          )}
        </div>
      </div>

      <div class="${klass.curation_latest}">
        ${is_mobile
          ? html`<span class="${classes(klass.section_title, font('18_semibold'))}">
              ${ET('curation::curation_detail_page::section_title')}
            </span>`
          : html`<div class="${klass.section}">
              <span class="${font('24_bold')}">${ET('curation::curation_detail_page::section_title')}</span>

              <a class="${klass.section_control}" href="${`/${ET.lang}/@/curations`}">
                <span class="${classes(klass.section_control_text, font('14_medium'))}"
                  >${ET('curation::curation_detail_page::section_control_text')}</span
                >

                <span class="${klass.icons_basic_enquad}">${IconsBasicEnquadArrowChevronRightIcon}</span>
              </a>
            </div>`}

        <div class="${klass.list}">
          ${pipe(
            curations,
            reject((curation) => curation.id === curation_detail.id),
            take(LATEST_CURATION_LIMIT),
            map(
              (curation) =>
                html`<article class="${klass.item}">
                  ${new CardCurationView({
                    device: is_mobile ? 'Mobile' : 'PC',
                    layout: 'Thumbnail',
                    ...curation,
                  })}
                </article>`,
            ),
            toArray,
          )}
        </div>

        ${is_mobile
          ? html`<div class="${klass.button_container}">
              ${new ButtonView(
                is_app && from_page === 'curation-feed'
                  ? {
                      size: 40,
                      color: 'Custom-A',
                      label: ET('curation::curation_detail_page::button_text'),
                      onClick: () => mpsPostMessage({ goBack: true }),
                    }
                  : {
                      size: 40,
                      color: 'Custom-A',
                      label: ET('curation::curation_detail_page::button_text'),
                      as: 'a',
                      href: `/${ET.lang}/@/curation-feed`,
                      dataset: {
                        postMessage: pipe(`/${ET.lang}/@/curation-feed`, makeEmptyScreenNavigate, dataStr),
                      },
                    },
              )}
            </div>`
          : null}
      </div>
    </div>`;
  }
}

export class CurationDetailPage extends Page<CurationDetailPageData> {
  override onMount() {
    super.onMount();
    const {
      layout_options: { is_mobile },
    } = this.data;
    const header_el = document.querySelector('.Header') as HTMLElement;
    const header_view = rune.getView(header_el, Header) as Header;

    // 헤드룸 offset 커스텀
    const padding_top_of_today_body = parseInt(window.getComputedStyle($qs('.today-body'))?.marginTop || '0');

    const header_element = header_view.element().querySelector(`.${header_klass.header}`) as HTMLDivElement;
    Header.initHeadroom(header_element, {
      ...header_view.state.headroom,
      use: true,
      offset: {
        up: padding_top_of_today_body,
        down: padding_top_of_today_body,
      },
    });

    const left_sidebar_el = $qs('.today-body__left_sidebar') as HTMLElement;

    if (!is_mobile) {
      listenDocumentEvent('header_pinned', () => {
        left_sidebar_el.classList.remove('unpinned');
      });
      listenDocumentEvent('header_unpinned', () => {
        left_sidebar_el.classList.add('unpinned');
      });
      listenDocumentEvent('header_top', () => {
        left_sidebar_el.classList.add('top');
      });
      listenDocumentEvent('header_nottop', () => {
        left_sidebar_el.classList.remove('top');
      });
    }

    go(
      this.element(),
      $delegate('click', '.share-btn', (e) => {
        const is_app = MShopUtilF.isApp();
        const title = e.currentTarget.dataset.title;
        const ua = new UAParser();
        const app_version = (/MarppleShopApp@(\w+.\w+.\w+)/gm.exec(ua.getUA()) || [])[1];

        if (is_app && app_version && app_version >= '1.1.0') {
          return MShopUtilF.postMessage({
            share: {
              title: `${T('마플샵')} - ${title}`,
              url: location.href,
            },
          });
        }

        try {
          navigator.clipboard
            .writeText(location.href)
            .then(() => {
              MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
            })
            .catch(() => {
              MShopUtilF.popToastMsg(T('s_about::url_failed'), 'info');
            });
        } catch (e) {
          MShopUtilF.clipboard(location.href);
          MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
        }
      }),
      $delegate('click', 'a', (e) => {
        if (!e.currentTarget.href.includes('/@/todays/') || !MShopUtilF.isApp()) return;
        e.originalEvent.preventDefault();
        location.replace(e.currentTarget.href);
      }),
    );

    hydrateFeed(this.element());
  }

  protected override template(props: CurationDetailPageData): Html {
    const { curation_detail, layout_options } = this.data;

    const { is_mobile } = layout_options;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: new BodyView(props),
            footer_data: { ...footer_links, is_mobile, lang: ET.lang },
          },
          {
            full_width: is_mobile,
            floating_box: {
              share: is_mobile
                ? {
                    title: curation_detail.title,
                    description: curation_detail.sub_title,
                  }
                : undefined,
            },
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
